SystemJS.config( {
	paths: {
		'npm:': '/cfs-file/__key/system/js-ti-lib-npm-',
		'bundle:': '/cfs-file/__key/system/js-ti-lib-bundles/',
		'widget:e2e8:': '/cfs-file/__key/defaultwidgets/e2e80000000000000000000000000000-'
	},
	map: {
		'widget-supportcreateeditpost': 'widget:e2e8:127cbf6cc52541639126e7d55addaa66',
		'widget-inboxaccountactivityoptions': 'widget:e2e8:62e91258889d48b290aba92e52c21834',
		'widget-inboxnavigation': 'widget:e2e8:c715c930d5d74b359f1dee9507d4bcfa',
		'widget-inboxsubscriptions': 'widget:e2e8:a9817e635c194648a77bf1d4222e5499',
		'widget-threadtracking': 'widget:e2e8:ff387bf9cd5a4342a6a6335effa13601',
		knockout: 'bundle:knockout.js',
		'knockout-components': '/cfs-file/__key/system/js-ti-src/knockout_2D00_components.js',
		utility: '/cfs-file/__key/system/js-ti-src-utility',
		'jquery-outside-events': 'bundle:jquery_2D00_outside_2D00_events.js',
		'jquery-ui': 'bundle:jquery_2D00_ui.js',
		lodash: 'bundle:lodash.js',
		'sticky-table-headers': 'bundle:sticky_2D00_table_2D00_headers.js',
		'js-cookie': 'bundle:js_2D00_cookie.js',
		multiselect: 'bundle:multiselect.js',
		rxjs: 'bundle:rxjs.js',
		scrollmagic: 'bundle:scrollmagic.js',
		tablesorter: 'bundle:tablesorter.js',
		tslib: 'bundle:tslib.js',
		velocity: 'bundle:velocity.js',
		css: 'npm:systemjs_2D00_plugin_2D00_css/css.js',
		json: 'npm:systemjs_2D00_plugin_2D00_json/json.js',
		text: 'npm:systemjs_2D00_plugin_2D00_text/text.js'
	},
	packages: {
		'widget-supportcreateeditpost': {
			main: 'main.js',
			defaultExtension: 'js'
		},
		'widget-inboxaccountactivityoptions': {
			main: 'main.js',
			defaultExtension: 'js'
		},
		'widget-inboxnavigation': {
			main: 'main.js',
			defaultExtension: 'js'
		},
		'widget-inboxsubscriptions': {
			main: 'main.js',
			defaultExtension: 'js'
		},
		'widget-threadtracking': {
			main: 'main.js',
			defaultExtension: 'js'
		},
		utility: {
			defaultExtension: 'js'
		}
	},
	meta: {
		'*.css': { loader: 'css' },
		'*.less': { loader: 'css' },
		'*.htm': { loader: 'text' },
		'*.html': { loader: 'text' },
		'*.txt': { loader: 'text' },
		'*.xml': { loader: 'text' },
		'*.json': { loader: 'json' },
		'bundle:*': {
			format: 'cjs',
			deps: [ 'bundle:common.js' ]
		}
	}
} );
